import {
  BusinessOutlined as BusinessOutlinedIcon,
  CalendarMonthOutlined as CalendarMonthOutlinedIcon,
  CreditCardOutlined as CreditCardOutlinedIcon,
  EmailOutlined as EmailOutlinedIcon,
  GroupOutlined as GroupOutlinedIcon,
  HomeOutlined as HomeOutlinedIcon,
  BadgeOutlined as BadgeOutlinedIcon,
  LocationOnOutlined as LocationOnOutlinedIcon,
  PaymentsOutlined as PaymentsOutlinedIcon,
  PhoneOutlined as PhoneOutlinedIcon,
  ShieldOutlined as ShieldOutlinedIcon,
} from "@mui/icons-material";
import { Box, Chip, Divider, Typography } from "@mui/material";
import { FormatDateBR } from "src/shared/Utils/FormatDateBR";
import { ModernCard } from "../shared/ModernCard";
import { ModernInfoItem } from "../shared/ModernInfoItem";
import { useProducerInternalData } from "../../hooks/useProducerInternalData";

export const TabInformacoes = () => {
  const { producerForm, producerListItem, metrics } = useProducerInternalData();
  const enderecoCompleto = [producerForm.endereco, producerForm.bairro].filter(Boolean).join(" - ");
  const localizacao = [producerForm.cidade, producerForm.estado].filter(Boolean).join(", ");
  const emailAcesso = producerForm.email || producerListItem?.email;

  return (
    <ModernCard title="Dados Cadastrais">
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
        Informacoes principais
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1 }}>
        <ModernInfoItem
          icon={<BadgeOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Nome completo"
          value={producerForm.nome}
        />
        <ModernInfoItem
          icon={<EmailOutlinedIcon sx={{ fontSize: 16 }} />}
          label="E-mail de acesso"
          value={emailAcesso}
        />
        <ModernInfoItem
          icon={<CreditCardOutlinedIcon sx={{ fontSize: 16 }} />}
          label="CPF/CNPJ"
          value={producerForm.cpf_cnpj}
        />
        <ModernInfoItem
          icon={<EmailOutlinedIcon sx={{ fontSize: 16 }} />}
          label="E-mail"
          value={producerForm.email_contato}
        />
        <ModernInfoItem
          icon={<PhoneOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Telefone"
          value={producerForm.telefone1}
        />
        <ModernInfoItem
          icon={<LocationOnOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Localizacao"
          value={localizacao || "-"}
        />
        <ModernInfoItem
          icon={<ShieldOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Status de acesso"
          value={metrics.acessoOnline}
        />
        <ModernInfoItem
          icon={<CalendarMonthOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Data de nascimento"
          value={producerForm.data_nasc ? FormatDateBR(producerForm.data_nasc) : "-"}
        />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap", mt: 1.5 }}>
        <Chip
          size="small"
          label={metrics.acessoOnline}
          color={producerListItem?.is_active_access_producer ? "success" : "default"}
        />

      </Box>

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
        Endereco e vinculos
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1 }}>
        <ModernInfoItem
          icon={<HomeOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Endereco"
          value={enderecoCompleto || "-"}
        />
        <ModernInfoItem label="CEP" value={producerForm.cep} />
        <ModernInfoItem
          icon={<BusinessOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Filial"
          value={producerListItem?.filial?.nome}
        />
        <ModernInfoItem
          icon={<GroupOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Gerente"
          value={producerListItem?.gerente?.nome}
        />
        <ModernInfoItem
          icon={<GroupOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Supervisor"
          value={producerListItem?.supervisor?.nome}
        />
        <ModernInfoItem
          icon={<PhoneOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Telefone secundario"
          value={producerForm.telefone2}
        />
      </Box>

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
        Classificacao
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1 }}>
        <ModernInfoItem
          icon={<BadgeOutlinedIcon sx={{ fontSize: 16 }} />}
          label="RG"
          value={producerForm.rg}
        />
        <ModernInfoItem label="Funcao" value={producerForm.funcao_produtor} />
        <ModernInfoItem label="Tipo produtor" value={producerForm.tipo_produtor} />
        <ModernInfoItem label="Tipo pessoa" value={producerForm.fisico_juridico} />
        <ModernInfoItem label="Grupo de imposto" value={producerListItem?.grupoImposto?.nome} />
        <ModernInfoItem
          icon={<CalendarMonthOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Data de entrada"
          value={producerForm.entrada ? FormatDateBR(producerForm.entrada) : "-"}
        />
        <ModernInfoItem
          icon={<CalendarMonthOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Data de saida"
          value={producerForm.saida ? FormatDateBR(producerForm.saida) : "-"}
        />
      </Box>

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
        Dados Bancarios
      </Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 1 }}>
        <ModernInfoItem
          icon={<PaymentsOutlinedIcon sx={{ fontSize: 16 }} />}
          label="PIX"
          value={producerForm.pix}
        />
        <ModernInfoItem
          icon={<CreditCardOutlinedIcon sx={{ fontSize: 16 }} />}
          label="Banco"
          value={producerForm.banco}
        />
        <ModernInfoItem label="Agencia" value={producerForm.agencia} />
        <ModernInfoItem label="Conta" value={producerForm.conta} />
        <ModernInfoItem label="Favorecido" value={producerForm.favorecido} />
      </Box>

      <Divider sx={{ my: 2 }} />

      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 700 }}>
        Observacoes
      </Typography>
      <Box sx={{ mb: 2 }}>
        <ModernInfoItem label="Anotacoes internas" value={producerForm.observacoes} />
      </Box>
    </ModernCard>
  );
};
